import { render } from "./areaAnnotation.vue?vue&type=template&id=7ad74e65&scoped=true"
import script from "./areaAnnotation.vue?vue&type=script&lang=js"
export * from "./areaAnnotation.vue?vue&type=script&lang=js"

import "./areaAnnotation.vue?vue&type=style&index=0&id=7ad74e65&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad74e65"]])

export default __exports__